<template>
    <div id="chargehistory">
        <Header />
            <div class="container">
                <div class="menu_left_box">
                    <Chargenav :selectedType="NavSelecteType" />
                </div>
                <div class="chargehistory_box">
                    <div class="title">
                        <h1>포인트 충전내역</h1>
                    </div>
                    <div class="searchArea">
                        <div class="searchOption">
                            <!-- <select v-model="selectedCurrencyIdx" @change="changeCurrency()">
                                <option value="-1">전체 종목</option>
                                <option v-for="(item, index) in $store.state.currencyList" :key="index" :value="item.idx">{{item.name}}</option>
                            </select>
                            -->
                            <datepicker :format="customFormatter" class="date date1" v-model="startDate" :language="ko" v-on:closed="changeStartDate()"></datepicker>
                            <span class="wave">~</span>
                            <datepicker :format="customFormatter" class="date date2" v-model="endDate" :language="ko" v-on:closed="changeEndDate()"></datepicker>
                        </div>
                        <div class="button" @click="getChargeHistory">
                            <p>조회</p>
                        </div>
                    </div>
                    <div class="table_box">
                        <table>
                            <tr>
                                <th class="date">날짜</th>
                                <th>결제금액</th>
                                <th>아트포인트 지급</th>
                                <th>보너스 포인트 지급</th>
                                <th>합계</th>
                            </tr>
                            <tr class="list1" v-for="(item, index) in chargeHistoryList" :key="index" :class="[index % 2 === 1 ? 'dark' : '']">
                                <td>{{item.createDate.substring(0,16)}}</td>
                                <td>{{item.price | comma}}</td>
                                <td>{{item.pointBase | comma}}</td>
                                <td>{{item.pointBonus | comma}}</td>
                                <td>{{item.pointBase + item.pointBonus | comma}}</td>
                            </tr>
                        </table>
                    </div>
                    <div class="no_history">
                        <img src="../assets/images/icon_no_history.svg" />
                        <p>출금 내역이 없습니다.</p>
                    </div>
                    <ul class="pagination" v-if="totalRecordSize > 0">
                        <li class="left" @click="prevPage()"><img src="../assets/images/icon_left_arrow.svg" /></li>
                        <li class="current" v-if="pageList.length <= 0">1</li>
                        <li v-for="(item, index) in pageList" :key="index" :class="{'on' : item === currentPageNo}" @click="movePage(item)">{{item}}</li>
                        <li class="right" @click="nextPage()"><img src="../assets/images/icon_right_arrow.svg" /></li>
                    </ul>
                </div>
            </div>
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Chargenav from '../components/Chargenav.vue'
import Datepicker from 'vuejs-datepicker';
import {ko} from 'vuejs-datepicker/dist/locale'

export default {
    name: 'Home',
        pageCategory: '',
        components: {
            Header,
            Footer,
            Chargenav,
            Datepicker,
    },
    data() {
        return {
            NavSelecteType: 'ChargeHistory',

            ko: ko,
            startDate: '',
            endDate: '',
            lastStartDate: '',
            lastEndDate: '',

            chargeHistoryList:[],

            currentPageNo: 1,      //현재 페이지 번호
            currentPageSize: 10,    //한번에 불러올 게시물 수
            maxPageCount:10,        //한 화면에 보여질 페이지 수

            listCount: 0,
            pageCount: 0,
            pageNo: 0,
            pageSize: 0,
            totalRecordSize: 0,

            pageList:[]
        }
    },
    created(){
        this.setDefaultDate();
        this.getChargeHistory();
    },
    methods:{
        customFormatter(date){
            return this.$moment(date).format('YYYY-MM-DD');
        },
        leadingZeros(n, digits) {
            var zero = '';
            n = n.toString();
            if (n.length < digits) {
                for (var i = 0; i < digits - n.length; i++)
                    zero += '0';
            }
            return zero + n;
        },
        setDefaultDate(){
            var startDate = new Date();
            var endDate = new Date();
            startDate.setDate(startDate.getDate() - 6);
            var convertStartDate = this.leadingZeros(startDate.getFullYear(), 4) + '-' + this.leadingZeros(startDate.getMonth() + 1, 2) + '-' + this.leadingZeros(startDate.getDate(), 2);
            var convertEndDate = this.leadingZeros(endDate.getFullYear(), 4) + '-' + this.leadingZeros(endDate.getMonth() + 1, 2) + '-' + this.leadingZeros(endDate.getDate(), 2);
            
            this.startDate = convertStartDate;
            this.lastStartDate = convertStartDate;
            
            this.endDate = convertEndDate;
            this.lastEndDate = convertEndDate;
        },
        changeStartDate(){
            var selectedStartDate = this.customFormatter(new Date(this.startDate));
            this.startDate = selectedStartDate;

            if(this.lastStartDate === this.startDate){
                return;
            }
            else{
                this.lastStartDate = this.startDate;

                // this.currentPageNo = 1;
                // this.listCount = 0;
                // this.pageCount = 0;
                // this.pageNo = 0;
                // this.pageSize = 0;
                // this.totalRecordSize = 0;
                // this.pageList = [];

                // this.getChargeHistory();
            }
        },
        changeEndDate(){
            var selectedEndDate = this.customFormatter(new Date(this.endDate));
            this.endDate = selectedEndDate;
            
            if(this.lastEndDate === this.endDate){
                return;
            }
            else{
                this.lastEndDate = this.endDate;

                // this.currentPageNo = 1;
                // this.listCount = 0;
                // this.pageCount = 0;
                // this.pageNo = 0;
                // this.pageSize = 0;
                // this.totalRecordSize = 0;
                // this.pageList = [];
                
                // this.getChargeHistory();
            }
        },
        prevPage(){
            if(this.currentPageNo > 1){
                this.currentPageNo--;
                this.getChargeHistory();
            }
        },
        nextPage(){
            if(this.currentPageNo < this.pageCount){
                this.currentPageNo++;
                this.getChargeHistory();
            }
        },
        movePage(no){
            if(this.currentPageNo === no)
                return;

            this.currentPageNo = no;
            this.getChargeHistory();
        },
        changePage(){
            this.pageList = [];
            if(this.pageCount === 0)
                return;

            var tmpPageNo = this.currentPageNo - 2;
            if(this.currentPageNo + 2 > this.pageCount){
                tmpPageNo--;
            }
            if(this.currentPageNo +1 > this.pageCount){
                tmpPageNo--;
            }
            for(var i=0; i<5 && tmpPageNo <= this.pageCount; ){
                if(tmpPageNo >= 1){
                    this.pageList.push(tmpPageNo);
                    i++;
                }
                tmpPageNo++;   
            }
        },
        getChargeHistory(){
            var param = 
            {
                apiStartDate: this.startDate,
                apiEndDate: this.endDate,
                pageNo: this.currentPageNo,
                pageSize: this.currentPageSize,
                sign: this.$store.state.sign,
                ticket: this.$store.state.ticket,
            }
            this.$Axios.post(`${this.host}/pnlink/history`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(async(res) => {
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    this.chargeHistoryList = res.data.list;
                    this.listCount       = res.data.page.listCount;
                    this.pageCount       = res.data.page.pageCount;
                    this.pageNo          = res.data.page.pageNo;
                    this.pageSize        = res.data.page.pageSize;
                    this.totalRecordSize = res.data.page.totalRecordSize;
                    this.changePage();
                }
                else{
                    this.$router.push('/');
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
    }
}
</script>
<style scoped>

</style>